import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import ReactModal from 'react-modal';

import { PlanImageRequest } from 'api/DeviceRequest';
import ErrorMessage from 'components/widget/ErrorMessage';
import { DEVICE_MODAL_TYPE, YN_TYPE } from 'types/enumType';

import { planImageSchema } from './resolver/deviceResolvers';

type PlanImageModalProps = {
  type: DEVICE_MODAL_TYPE;
  id: number;
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onSubmit: (formData: PlanImageRequest) => void;
};

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: 0,
    border: 0,
  },
};
export default function PlanImageModal({
  type,
  id,
  isOpen,
  isLoading,
  onClose,
  onSubmit,
}: PlanImageModalProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<PlanImageRequest>({
    resolver: planImageSchema,
  });

  useEffect(() => {
    if (!isOpen) {
      reset();
    } else {
      reset({ typeId: id, type, resetPos: YN_TYPE.N });
    }
  }, [isOpen, reset]);

  return (
    <ReactModal isOpen={isOpen} style={customStyles} onRequestClose={onClose}>
      <div id={'popup-wrap'}>
        <div className={'popup-wrap device-modal'} id={'etc-modal'}>
          <div className={'popup-head'}>
            <p className={'poptit'}>{'이미지 등록'}</p>
          </div>
          <div className={'popup-cont'}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className={'cont'}>
                <div className={'filter-wrap'}>
                  <div className={'filter'}>
                    <dl>
                      <dt>{'이미지'}</dt>
                      <dd>
                        <input
                          type={'file'}
                          accept={'image/*'}
                          {...register('image')}
                        />
                        <input
                          type={'hidden'}
                          defaultValue={id}
                          {...register('typeId')}
                        />
                        <input
                          type={'hidden'}
                          defaultValue={type}
                          {...register('type')}
                        />
                      </dd>
                    </dl>
                  </div>
                  <div className={'filter'}>
                    <dl>
                      <dt>{'위치정보 삭제 여부'}</dt>
                      <dd>
                        <ul className={'td-radio'}>
                          <li>
                            <input
                              type={'radio'}
                              id={'resetPosY'}
                              value={YN_TYPE.Y}
                              {...register('resetPos')}
                            />
                            <label htmlFor={'resetPosY'}>{'삭제'}</label>
                          </li>
                          <li>
                            <input
                              type={'radio'}
                              id={'resetPosN'}
                              value={YN_TYPE.N}
                              {...register('resetPos')}
                            />
                            <label htmlFor={'resetPosN'}>{'유지'}</label>
                          </li>
                        </ul>
                      </dd>
                    </dl>
                  </div>
                </div>
                <ErrorMessage errors={errors} />
                <div className={'btn-wrap'}>
                  <button
                    type={'submit'}
                    className={'orange_white_btn'}
                    disabled={isLoading}
                  >
                    {'저장'}
                  </button>
                  <button
                    type={'button'}
                    className={'gray_white_btn'}
                    onClick={onClose}
                  >
                    {'취소'}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </ReactModal>
  );
}
